import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encodeHtml'
})
export class EncodeHtmlPipe implements PipeTransform {

  private entityMap: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;',
    '/': '&#47;',
    '=': '&#61;'
  };

  transform(value: string): string {
    if (value === null || value === undefined) return '';

    const text = String(value);

    return text.replace(/[&<>"'`=\/]/g, (char) => this.entityMap[char] || char);
  }
}
